module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.1-132.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.1.md
// module id = 547
// module chunks = 251